import { render, staticRenderFns } from "./rasoIndex.vue?vue&type=template&id=1be28a4c&scoped=true&"
import script from "./rasoIndex.vue?vue&type=script&lang=js&"
export * from "./rasoIndex.vue?vue&type=script&lang=js&"
import style0 from "./rasoIndex.vue?vue&type=style&index=0&id=1be28a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be28a4c",
  null
  
)

export default component.exports